import dayjs from 'dayjs';

export const getTimeIn12HrFormat = (date: string, time: string) => {
  return dayjs(`${date} ${time}`).format('h:mmA');
};
